import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

const CNDialog = ({
  open,
  onClose,
  onSubmit,
  currentBoxId,
  defaultSelected = ["all", "expiry", "damaged", "saleable"],
}) => {
  const [selectedOrders, setSelectedOrders] = useState(defaultSelected);

  const orderOptions = ["all", "expiry", "damaged", "saleable"];

  const handleToggleOption = (option) => {
    if (option === "all") {
      setSelectedOrders(
        (prev) =>
          prev.includes("all")
            ? [] // uncheck all
            : ["all", "saleable", "damaged", "expiry"] // check all
      );
    } else {
      setSelectedOrders((prev) => {
        const newSelection = prev.includes(option)
          ? prev.filter((o) => o !== option)
          : [...prev, option];

        // keep "all" in sync
        const withoutAll = newSelection.filter((o) => o !== "all");
        if (
          withoutAll.length === 3 && // all individual options selected
          !newSelection.includes("all")
        ) {
          return [...withoutAll, "all"];
        } else if (withoutAll.length < 3) {
          return withoutAll;
        }
        return newSelection;
      });
    }
  };

  const handleSubmit = () => {
    let finalOrders = [...selectedOrders];
    if (finalOrders.includes("all")) {
      finalOrders = ["saleable", "damaged", "expiry"];
    }
    onSubmit(currentBoxId, finalOrders);
    setSelectedOrders(["all", "saleable", "damaged", "expiry"]); // reset after submit
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      BackdropProps={{
        sx: { backgroundColor: "rgba(0, 0, 0, 0.3)" }, // lighter & translucent
      }}
    >
      <DialogTitle>Select Order Types</DialogTitle>
      <DialogContent>
        {orderOptions.map((option) => (
          <FormControlLabel
            key={option}
            control={
              <Checkbox
                checked={selectedOrders.includes(option)}
                onChange={() => handleToggleOption(option)}
              />
            }
            label={option.charAt(0).toUpperCase() + option.slice(1)}
          />
        ))}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setSelectedOrders(["all", "saleable", "damaged", "expiry"]);
            onClose();
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={selectedOrders.length === 0}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CNDialog;
